import _map from 'lodash/map';
import React, { Component, PropTypes } from 'react';
import ComponentTitle from '../shared/ComponentTitle';
import SocialIcon from '../social/SocialIcon';
import Slideshow from 'components/icons/Slideshow';
import Image from 'components/Image';
import Swipeable from 'react-swipeable';
import injectTapEventPlugin from "react-tap-event-plugin";
import { TITLE_TYPE } from '../../constants/FRNBaseStyles';
import convert from 'xml-js';
import translate from '../../utils/translate';

/**
 * Class representing an overview of the stations meteorologist team.
 *
 * Dependent on feed - weather_team_feed
 */

class WeatherTeamOverview extends Component {
  static propTypes = {
    titleColor: PropTypes.string,
    textColor: PropTypes.string,
    FRN_rawResponses: PropTypes.array,
    displayType: PropTypes.string,
    titleType: PropTypes.string
  };

  static contextTypes = {
    config: PropTypes.object.isRequired
  }

  _cleanXmlObj(arr) {
    return arr.map(obj => ({
      ...obj, 
      bio: obj.bio._cdata,
      image: obj.image._cdata,
      index: obj.index._cdata,
      name: obj.name._cdata,
      title: obj.title._cdata,
      email: obj.email ? obj.email._cdata : '',
      'facebook-url': obj['facebook-url'] ? obj['facebook-url']._cdata : '',
      'twitter-url': obj['twitter-url'] ? obj['twitter-url']._cdata : '',
      'google-url': obj['google-url'] ? obj['google-url']._cdata : '',

    }));
  }

  render() {
    if (!this.props.FRN_rawResponses || this.props.FRN_rawResponses.length === 0) {
      return null;
    }
    const {
      config: {
        appOptions: {
          language = 'en'
        } = {}
      } = {}
    } = this.context;
    
    const {
      titleColor,
      textColor,
      FRN_rawResponses = [],
      displayType,
      titleType = TITLE_TYPE.MODULE_TITLE
    } = this.props;

    const groups = [];

    FRN_rawResponses.forEach((response) => {
      //Frankly JSON feed
      if (response.data && response.data.features) {
        const features = [];
        response.data.features.forEach((item) => {
          /*The features contain both stories and menus, we just go with the stories.
           email, facebook-url and twitter-url are currently not supported by the Frankly JSON feed.
           */
          if (item.type === 'story') {
            const feature = {
              name: item.headline,
              title: item.abstract,
              bio: item.link,
              image: item.abstractimage ? item.abstractimage.filename : null,
              email: '',
              'facebook-url': '',
              'twitter-url': ''
            };
            features.push(feature);
          }
        });

        const group = {
          '@title': response.data.headline,
          '@category-url': response.data.link,
          personalities: { person: features }
        };

        groups.push({ data: { group } });
      } else { //XML feed
        groups.push(response);
      }
    });

    let title = 'Meet the team';
    let meteorologists = [];
    
    if (groups && groups.length > 0 && groups[0].data) {
      let dataStr = groups[0].data;
      if (dataStr && typeof dataStr === 'string') {
        try {
          groups[0].data = convert.xml2js(dataStr, {compact: true});
          groups[0].data.group.personalities.person = this._cleanXmlObj(groups[0].data.group.personalities.person);
        } catch (error) {
          console.log(error);
        }
      }

      [{
            data: {
              group: {
                '@title': title = 'Meet the team',
                personalities: {
                  person: meteorologists = []
                } = {}
              } = {}
            }
      }] = groups;
    }

    // Handle different kind of uppercase/lowercase of 'meet the team' string
    // transform it to match the translate.js dictionary
    if (title.match(/meet the team/i)) {
      title = 'Meet the team';
    }

    if (!meteorologists.length) {
      return null;
    }

    let content;

    if (displayType === 'slider') {
      content = (
        <SliderTeamOverview items={meteorologists} textColor={textColor}/>
      );
    } else {
      content = (
        <div className="WeatherTeamOverview-contents">
          {_map(meteorologists, (data, i) =>
            <div className="u-fullWidth" key={i}>
              <MeteorologistCard meteorologistData={data} textColor={textColor} />
            </div>)}
        </div>
      );
    }

    return (
      <div className='WeatherTeamOverview'>
        <ComponentTitle titleType={titleType} title={translate(title, language)} classes="WeatherTeamOverview-header" color={titleColor} />
        {content}
      </div>
    );
  }
}

/**
 * Class representing a single meteorologist card, including photo, name and social contact information.
 *
 * Dependent on feed - weather_team_feed
 */
class MeteorologistCard extends Component {
  static propTypes = {
    textColor: PropTypes.string,
    meteorologistData: PropTypes.object.isRequired
  };

  render() {
    const {
      textColor,
      meteorologistData
    } = this.props;
    const {
      email = '',
      'facebook-url': facebookInfo = '',
      'twitter-url': twitterInfo = '',
      'google-url': googleInfo = ''
    } = meteorologistData;

    const customStyles = {
      color: textColor
    };

    /* Breakpoints: XS: 0-767, S: 768-991, M: 992-1199, L: 1200-1469, XL: 1470-  */
    // const imageBreakpoints = [
    //   { "maxWidth": 640, "widthPX": 256 },
    //   { "maxWidth": 768, "widthPX": 308 },
    //   { "maxWidth": 992, "widthPX": 397 },
    //   { "maxWidth": 1200, "widthPX": 480 },
    //   {                   "widthPX": 560 },
    // ];

    return (
      <div className="MeteorologistCard">
        <a target="_top" href={meteorologistData.bio} className="MeteorologistCard-profileImageLink">
          <Image src={meteorologistData.image} width={190} forceDPR alt={'Image of ' + meteorologistData.name} imageClassNames={"MeteorologistCard-profileImage"} />
        </a>
        <div className="MeteorologistCard-info">
          <a target="_top" href={meteorologistData.bio} className="MeteorologistCard-textLink" style={customStyles}>
            <h3 className="MeteorologistCard-name" style={customStyles} dangerouslySetInnerHTML={{ __html: meteorologistData.name}}>
            </h3>
            <h5 className="MeteorologistCard-title" style={customStyles} dangerouslySetInnerHTML={{ __html: meteorologistData.title}}>
            </h5>
          </a>
          <div className="MeteorologistCard-socialInfo">
            {facebookInfo ? <SocialIcon iconType="facebook" destinationUri={facebookInfo} /> : null}
            {twitterInfo ? <SocialIcon iconType="twitter" destinationUri={twitterInfo} /> : null}
            {googleInfo ? <SocialIcon iconType="google" destinationUri={googleInfo} /> : null}
            {email ? <SocialIcon iconType="email" destinationUri={'mailto:' + email} noTarget /> : null}
          </div>
        </div>
      </div>
    );
  }

}

class SliderTeamOverview extends Component {
  static propTypes = {
    textColor: PropTypes.string,
    items: PropTypes.array.isRequired
  }

  constructor(props) {
    super(props);
    injectTapEventPlugin({
      shouldRejectClick: () => {
        return true;
      }
    });
    this.firstCard = null;
    this.cardWrapper = null;
  }

  state = {
    transform: 0,
    activeIndex: 0,
    canNext: false,
    canBack: false
  }

  componentDidMount() {
    this._showNextArrow();
  }

  _showNextArrow() {
    if (this.props.items.length * this._getFirstCardWidth() > this._getCardWrapperWidth()) {
      this.setState({ canNext: true });
    }
  }

  _handleSwipe(e, x) {
    if (x > 0) {
      this._next();
    } else {
      this._back();
    }
  }

  _handleTouchTap() {
    this._next();
  }

  _next() {
    const { items } = this.props;
    const { transform, activeIndex } = this.state;
    let { canNext } = this.state;
    const firstCardWidth = this._getFirstCardWidth();
    const cardWrapperWidth = this._getCardWrapperWidth();
    const leftWidth = (items.length - activeIndex) * firstCardWidth;

    if (leftWidth > cardWrapperWidth) {
      let newTransform = transform;
      const prev = cardWrapperWidth + firstCardWidth - transform === items.length * firstCardWidth;

      if (leftWidth - cardWrapperWidth < firstCardWidth && !prev) {
        newTransform -= (leftWidth - cardWrapperWidth);
        canNext = false;
      } else {
        newTransform -= firstCardWidth;
        canNext = true;
      }

      if (leftWidth === cardWrapperWidth + firstCardWidth || prev) {
        canNext = false;
      }

      this.setState({
        transform: newTransform,
        activeIndex: activeIndex + 1,
        canBack: true,
        canNext
      });
    }
  }

  _back() {
    const { activeIndex } = this.state;
    let { transform, canBack } = this.state;
    const firstCardWidth = this._getFirstCardWidth();

    if (transform + firstCardWidth >= 0) {
      transform = 0;
      canBack = false;
    } else {
      transform += firstCardWidth;
      canBack = true;
    }

    if (transform <= 0 && activeIndex > 0) {
      this.setState({
        transform,
        activeIndex: activeIndex - 1,
        canNext: true,
        canBack
      });
    }
  }

  _getFirstCardWidth() {
    return this.firstCard.clientWidth;
  }

  _getCardWrapperWidth() {
    return this.cardWrapper.clientWidth;
  }

  render() {
    const {
      items,
      textColor = ''
    } = this.props;

    const {
      transform,
      canNext,
      canBack
    } = this.state;

    const content = [];

    const customStyles = {
      color: textColor
    };

    items.forEach((item, index) => {
      const {
        bio = '',
        image = '',
        name = '',
        title = '',
        email = '',
        'facebook-url': facebookInfo = '',
        'twitter-url': twitterInfo = '',
        'google-url': googleInfo = ''
      } = item;

      content.push(
        <div key={index}
             className="SliderTeamOverview-teamCard"
             ref={(div) => this.firstCard = div}>
          <div className="thumbnail">
            <Image src={image} alt={name} width={190} forceDPR />
          </div>
          <div className="SliderTeamOverview-text">
            <a target="_top" href={bio} style={customStyles}>
              <div className="SliderTeamOverview-bioInfo">
                <p className="person" dangerouslySetInnerHTML={{ __html: name}}></p>
                <p className="job" dangerouslySetInnerHTML={{ __html: title}}></p>
              </div>
            </a>
            <div className="SliderTeamOverview-cardButtons">
              {facebookInfo ? <SocialIcon iconType="facebook" destinationUri={facebookInfo} /> : null}
              {twitterInfo ? <SocialIcon iconType="twitter" destinationUri={twitterInfo} /> : null}
              {googleInfo ? <SocialIcon iconType="google" destinationUri={googleInfo} /> : null}
              {email ? <SocialIcon iconType="email" destinationUri={'mailto:' + email} noTarget /> : null}
            </div>
          </div>
        </div>
      );
    });

    return (
      <div className="SliderTeamOverview">
        <div className="SliderTeamOverview-row">
          {canBack ? <div className="SliderTeamOverview-backBtn hidden-xs" onClick={() => this._back()}><Slideshow direction="left" /></div> : null}
          <Swipeable onSwiped={(e, x) => this._handleSwipe(e, x)}>
            <div className="SliderTeamOverview-itemWrapper" ref={(div) => this.cardWrapper = div} onTouchTap={() => this._handleTouchTap()}>
              <div className="SliderTeamOverview-swapCard" style={{transform: `translate(${transform}px, 0)`, transition: `all 0.25s linear`}}>
                {content}
              </div>
            </div>
          </Swipeable>
          {canNext ? <div className="SliderTeamOverview-nextBtn hidden-xs" onClick={() => this._next()}><Slideshow direction="right" /></div> : null}
        </div>
      </div>
    );
  }
}

export default WeatherTeamOverview;



// WEBPACK FOOTER //
// ./app/components/weather/TeamOverview.js